import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import {
  clearUnfinalizedPrescription,
  prescriptionPageTabShowItemList,
  setUnfinalizedPrescriptionId,
} from "../../actions/prescriptionAction";
import RxIcon from "../../assets/images/rx-icon.png";
import { getUserDetail } from "../../utils/helper";
import ConfirmDialog from "../ConfirmDialog";
import history from "../../utils/history";
import { renderFormulaList } from "../../actions/formulaAction";
import { getShippingPrice } from "../../actions/profileAction";
const CartItem = ({ item, ship_id }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role.role);
  const removeItem = () => {
    let roleId = role.val == 3 ? role.val : role.val == 4 ? role.val : 1;
    var params = {
      params: {
        action: "removeCartItem",
        itemId: item.prescriptionId,
        itemType: 1,
        roleId: roleId,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
        dispatch(getShippingPrice(ship_id, role.val));
      })
    );
  };

  const editItem = () => {
    dispatch(setUnfinalizedPrescriptionId(item.prescriptionId));
    dispatch(prescriptionPageTabShowItemList([3]));
    dispatch(clearUnfinalizedPrescription());
    dispatch(UndoActionCreators.clearHistory());
    dispatch(renderFormulaList(true));

    if (item.isWhiteLabel) {
      history.push("/app/whitelabel", "editFromCart");
    } else {
      history.push("/app/prescription", "editFromCart");
    }
  };

  return (
    <div>
      {showConfirmDialog && (
        <ConfirmDialog
          title="Are you sure want to remove this item?"
          acceptAction={removeItem}
          acceptText="yes"
          rejectText="no"
          closePopup={() => setShowConfirmDialog(false)}
        />
      )}
      <div className="cart_container" id="cart_content">
        {role.val !== 3 && (
          <div className="d-flex justify-content-end mr-2">
            <button className="btn btn-orange" onClick={editItem}>
              edit
            </button>
          </div>
        )}
        <div className="cart-icon" style={{ padding: "5px" }}>
          <div
            className="cart-cancel"
            onClick={() => setShowConfirmDialog(true)}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </div>
          <img
            style={{ marginLeft: "0px", position: "relative", bottom: "12px" }}
            width="30"
            height="30"
            src={RxIcon}
            alt="rx-icon"
          />
        </div>
        <div className="cart-item">
          {item.isPromo ? (
            <p style={{ marginBottom: "0px" }}>
              Promo Code: {item.description}
            </p>
          ) : (
            <p style={{ marginBottom: "0px" }}>{item.description}</p>
          )}
          <p style={{ marginBottom: "0px" }}>
            Preparation Method:&nbsp;
            <span>{item.prep_name}</span>
          </p>
          {item.formula ? (
            <p style={{ marginBottom: "0px" }}>
              Formula Name:&nbsp;
              <span>{item.formula}</span>
            </p>
          ) : (
            ""
          )}
        </div>
        {!item.isPromo && (
          <>
            <div className="cart-weight">
              <p style={{ display: "inline-block" }}>
                Weight:&nbsp;
                <span>
                  {parseFloat(item.weight).toLocaleString("en-US", {
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1,
                  })}{" "}
                  grams
                </span>
              </p>
            </div>
          </>
        )}
        <div className="cart-total">
          <p
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "0px",
            }}
          >
            Price
          </p>
          <p>
            {parseFloat(item.total).toLocaleString("en-US", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              style: "currency",
              currency: "USD",
            })}
          </p>
        </div>
      </div>
    </div>
  );
};
export default CartItem;
